/**
 * 岗位规则组导入
 */
import React from "react";
import { connect } from 'dva';
import { framework_tool, component_tool } from '@/tool'
import 'antd/dist/antd.css';
import { modelUtils } from '@/utils';

let { WizContainer } = framework_tool;
import { ExportExcel } from '@/components/index'
import { width } from "dom7";

let { WizSpin, WizTypography, WizModal, WizSelect } = component_tool;
const { Paragraph } = WizTypography;

class PositionRuleImport extends WizContainer {

  componentName = 'positionRuleImport';

  constructor(props) {
    super(props);
    this.state = {
      scope: props.scope ? props.scope : 1,
      requirement: props.requirement ? props.requirement : 1 //考核要求   1按完成状态  2按参训时长
    }
  }


  /**改变state值 */
  changeScope(key,value){
    this.setState({[key]:value})
  }


  _render() {
    let examId = this.props.examId;
    let infoProps = {
      title: '导入说明',
      text: [
        <Paragraph>1、从模版链接中下载模版文件</Paragraph>,
        <Paragraph>2、按照要求格式填写信息</Paragraph>,
        <Paragraph>3. 当完成Excel文件的填写后，点击“上传文件”按钮上传此文件，并点击“导入”系统会校验数据的正确性，并提示错误的数据；在校验无错误的情况下，将数据导入到系统中。</Paragraph>,
      ]
    }

    let excelFile = constants.files.excel_programAssessmentRulesTemp;
    if(this.state.requirement==2){
      excelFile = constants.files.excel_vctAssessmentRulesTemp;
    }

    let operateProps = {
      title: '导入岗位组考核规则',
      template: {
        label: '模版下载',
        fileName: '岗位组考核规模版.xlsx',
        href: excelFile,
      }

    }
    let submit = (file, fileData) => {
      if(!this.state.scope){
        wizNotice.info('请选择考核范围！');
        return;
      }
      if(!this.state.requirement){
        wizNotice.info('请选择考核要求！');
        return;
      }
      if(this.props.importPositionRule){
        this.props.importPositionRule({
          fileData:fileData,
          requirement:this.state.requirement,
          scope:this.state.scope
        })
      }
    }
    let { positionRuleLoading } = this.props;

    let other = [
      {
        item: { label: '考核范围', required: true },
        comp: (callback) => {
          return (
            <WizSelect style={{width:200}}
              placeholder="请选择考核范围"
              onChange={this.changeScope.bind(this,'scope')}
              defaultValue={1}
            >
              <Option value={1}>销售</Option>
              <Option value={2}>售后</Option>
              <Option value={3}>销售售后</Option>
            </WizSelect>
          )
        }
      },
      {
        item: { label: '考核要求', required: true },
        comp: (callback) => {
          return (
            <WizSelect style={{width:200}}
              placeholder="请选择考核要求"
              onChange={this.changeScope.bind(this,'requirement')}
              defaultValue={1}
            >
              <Option value={1}>按完成状态</Option>
              <Option value={2}>按参训时长</Option>
            </WizSelect>
          )
        }
      }
    ]

    return (
      <WizSpin tip={'文件上传中'} spinning={positionRuleLoading}>
        <ExportExcel
          infoProps={infoProps}
          operateProps={operateProps}
          submit={submit}
          other={other}
        />
      </WizSpin>
    );
  }
}


const mapStateToProps = (state, ownProps) => {
  const { positionRule } = state;
  //获取loading的方式
  const load = modelUtils.getLoadingState(state, 'positionRule')
  return {
    ...load
  }
};

export default connect(mapStateToProps)(PositionRuleImport);
